import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const SESSION_DURATION = 30 * 60 * 1000;// ✅ 2 hours in milliseconds

const useSessionTimeout = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const logout = async() => {

    try {
      await fetch(`${import.meta.env.VITE_API_URL}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("Auto logout failed", err);
    }
    clearTimer();
    alert("Your session has expired. Please login again.");
    navigate("/signin", { replace: true });
  };

  const startTimer = () => {
    clearTimer();

    timeoutRef.current = setTimeout(() => {
      logout();
    }, SESSION_DURATION);
  };

  useEffect(() => {
    startTimer();

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    const resetTimeoutHandler = () => {
      startTimer(); // ✅ activity par 2 hours reset
    };

    events.forEach((event) =>
      document.addEventListener(event, resetTimeoutHandler, true)
    );

    return () => {
      clearTimer();
      events.forEach((event) =>
        document.removeEventListener(event, resetTimeoutHandler, true)
      );
    };
  }, [navigate]);

  return { resetTimeout: startTimer };
};

export default useSessionTimeout;
